import { render, staticRenderFns } from "./TierPage.vue?vue&type=template&id=44d8afc8&scoped=true&"
import script from "./TierPage.vue?vue&type=script&lang=js&"
export * from "./TierPage.vue?vue&type=script&lang=js&"
import style0 from "./TierPage.vue?vue&type=style&index=0&id=44d8afc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d8afc8",
  null
  
)

export default component.exports